import { render, staticRenderFns } from "./nationality.vue?vue&type=template&id=7d617ca0&scoped=true&"
import script from "./nationality.vue?vue&type=script&lang=js&"
export * from "./nationality.vue?vue&type=script&lang=js&"
import style0 from "./nationality.vue?vue&type=style&index=0&id=7d617ca0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d617ca0",
  null
  
)

export default component.exports